import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

import type { Color } from '@opendoor/tokens-studio/dist/bricks-next/types/Novo';
import { getToken } from '@tamagui/core';

type BricksSvgProps = Omit<SvgProps, 'width' | 'height' | 'color'> & {
  size?: 20 | 24,
  color?: Color,
};
const SvgFavoriteUnfilled = ({
  size = 24,
  color = '$contentPrimary',
  ...inProps
}: BricksSvgProps) => {
  const outProps: SvgProps = {};
  if (size) {
    outProps.width = size;
    outProps.height = size;
  }
  if (color) {
    const colorToken = getToken(color, 'color');
    outProps.color = colorToken;
  }
  const props = {
    viewBox: '0 0 24 24',
    ...inProps,
    ...outProps,
  };
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
      <Path
        fill="currentColor"
        d="M12 21.958q-.349 0-.713-.125a1.65 1.65 0 0 1-.637-.4l-1.725-1.575a68 68 0 0 1-4.788-4.812Q2.002 12.658 2 9.783q0-2.35 1.575-3.925T7.5 4.283q1.325 0 2.5.563t2 1.537a5.96 5.96 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575T22 9.783q0 2.875-2.125 5.275a60 60 0 0 1-4.825 4.825l-1.7 1.55a1.65 1.65 0 0 1-.637.4q-.363.125-.713.125m-.95-13.575q-.725-1.025-1.55-1.562t-2-.538q-1.5 0-2.5 1t-1 2.5q0 1.3.925 2.763t2.213 2.837a38 38 0 0 0 2.65 2.575q1.362 1.2 2.212 1.975.85-.775 2.213-1.975t2.65-2.575a19 19 0 0 0 2.212-2.837Q20 11.083 20 9.783q0-1.5-1-2.5t-2.5-1q-1.175 0-2 .538-.825.537-1.55 1.562a1.14 1.14 0 0 1-.95.5 1.138 1.138 0 0 1-.95-.5"
      />
    </Svg>
  );
};
export default SvgFavoriteUnfilled;
